<template>
  <v-flex>
    <v-form id="admin-login" @submit.prevent="login()">
      <transition name="fade-in-down" appear appear-active-class="animated fadeInDown">
        <v-flex xs12 sm6 d-flex id="email-container">
          <v-text-field
            v-model="adminForm.email"
            :label="$t('Enter Email')"
            name="email"
            background-color="rgba(255,255,255,0.85)"
            v-validate="'required|email'"
            data-vv-validate-on="blur|change"
            solo
            autocomplete="off"
            autofocus
            prepend-inner-icon="fa-at"
            style="flex-grow:2"
          />
        </v-flex>
      </transition>

      <transition name="fade-in-down" appear appear-active-class="animated fadeInDown">
        <v-flex xs12 sm6 d-flex id="password-container">
          <v-text-field
            v-model="adminForm.password"
            :label="$t('Enter Password')"
            name="password"
            :type="showPassword ? 'text' : 'password'"
            :append-icon="showPassword ? 'visibility' : 'visibility_off'"
            @click:append="showPassword = !showPassword"
            background-color="rgba(255,255,255,0.85)"
            v-validate="'required|min:6'"
            data-vv-validate-on="blur|change"
            solo
            autocomplete="off"
            prepend-inner-icon="lock"
            style="flex-grow:2"
          />
        </v-flex>
      </transition>

      <transition name="fade-in-down" appear appear-active-class="animated fadeInDown">
        <v-flex id="login-btn-container">
          <v-btn color="success" large type="submit">
            {{ $t('Login') }}
            <v-icon v-if="$vuetify.rtl" left style="transform: rotate(180deg);">fa-sign-in-alt</v-icon>
            <v-icon v-if="!$vuetify.rtl" right>fa-sign-in-alt</v-icon>
          </v-btn>
        </v-flex>
      </transition>
    </v-form>
  </v-flex>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import * as helpers from '@/mixins/helperFunctions'

export default {
  name: 'adminLogin',

  computed: {
    ...mapGetters({
      localeList: 'locale/getLocales',
      authUserData: 'auth/getAuthUserData'
    })
  },

  data: () => ({
    adminForm: {
      email: '',
      password: ''
    },
    showPassword: false,
    snackbar: false,
    timeout: 0
  }),

  methods: {
    ...mapActions({
      processLogin: 'auth/processLogin',
      setAuthUserData: 'auth/setAuthUserData',
      setCountriesList: 'locale/setCountriesList',
      setAuthToken: 'auth/setAuthToken'
    }),

    changeLanguage(lang) {
      // filter the available locales array for a matching value of the lang and get the first match
      let isRtl = false
      let direction = this.localeList.filter(l => l.value === lang)[0]

      // if no match then default to english, same for "dir" property default to "ltr" if not defined
      // or not "rtl"
      if (!direction) {
        lang = 'en'
      } else {
        isRtl = !!(direction.dir === 'rtl')
      }

      localStorage.setItem('language', lang)
      this.$vuetify.rtl = isRtl
      this.$i18n.locale = lang
      this.setCountriesList(lang)
      this.setRtl(isRtl)
    },

    login() {
      let theEmail = ''
      let thePassword = ''

      this.$validator
        .validateAll()
        .then(() => {
          if (!this.errors.any()) {
            theEmail = this.adminForm.email
            thePassword = this.adminForm.password

            this.$auth
              .login({
                data: { email: theEmail, password: thePassword },
                // body: { email: theEmail, password: thePassword },
                rememberMe: false,
                fetchUser: true,
                redirect: '/'
              })
              .then(response => {
                this.setAuthToken(response.data.access_token)
                // console.log(response.data.access_token)
              })
              .then(() => {
                setTimeout(() => {
                  this.changeLanguage(this.authUserData.lang)
                }, 1000)
              })
              .catch(error => {
                let errRes = error.response
                if (errRes.status === 401) {
                  helpers.ktNotify({ type: 'error', text: '401 Unauthorized' })
                }
              })
          }
        })
        .catch(error => {
          console.error('Login Error:', error)
        })
    }
  }
}
</script>

<style scoped>
#email-container,
#password-container {
  width: 300px !important;
  margin-left: auto;
  margin-right: auto;
}
#email-container,
#password-container,
#login-btn-container {
  animation-delay: 0.5s;
}
.password-visibility {
  position: absolute;
  left: 10px;
  z-index: 10;
}

@media screen and (max-height: 760px) {
  #form-container {
    margin-bottom: 150px;
  }
}
</style>
